module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAaCAYAAAGhnG6pAAAAAXNSR0IArs4c6QAAAVpJREFUSA3lVTtuwkAQXVuiSJMjpKWkp0/PEcIROAAHSB2l5g6UOUEM6UJLxxEokJBi3qz00LKatcfI1iJlpPGsZ998Pbt2dV1vwZ6ciQrBElkIxQpueimb5Y3GuUWzSYT2rzcWBMTBqVdl0oOK7qREiVPfBHko9EFdo1cBNQJks7UKFZByKw1M7d2lRwlfDo9KimkjRgDuEGKpN0sYP4HPdGI2TALh6Xos6DUlVScpsKLfaA7yfkYtI7MOJY7B32aDEAjDHXskg2QhHwnAWQw2N7HTRRKmG6+RwXuYRbxveoeDEnwURyaDYUGShpGGGWXzZ+zaB+v1J/+vn67ODfitAfMPIRi2EXgJPnHwBm8DAj2DP8F/DBrK3oeQw4cgK1T31lahDKF6vtoME/sV9UhkjvUreE9dVomOTMCbsP2yzpIU4r6A1+DfLAk8VNDeTwGr42nge0pmv4ovY0QIoRLidlIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shelf-list/collapse.png
// module id = Pmgj
// module chunks = 1